import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { FilterButtonContainer, FilterButton as FilterButtonStyled } from './styles';
import { ChevronRight, FilterFunnel2Icon } from 'icons';
import { colors } from 'styles/colors';

interface FilterButtonProps {
  collapsed: boolean;
  onClick: () => void;
  disabled?: boolean;
}

export function FilterButton({
  collapsed,
  disabled,
  onClick,
}: Readonly<FilterButtonProps>): ReactElement {
  const { t } = useTranslation();

  const color = disabled ? colors.icon['disabled-300'] : colors.icon['primary-base'];

  return (
    <FilterButtonStyled
      onClick={onClick}
      type="button"
      variant="primary-stroke"
      aria-controls="filter-fields"
      aria-expanded={!collapsed}
      disabled={disabled}
    >
      <FilterButtonContainer disabled={disabled}>
        <FilterFunnel2Icon color={color} size="14" />
        <span>{t('filtros')}</span>
        <ChevronRight
          rotate={collapsed ? '90deg' : '270deg'}
          color={color}
          size="14"
        />
      </FilterButtonContainer>
    </FilterButtonStyled>
  );
}
